import {Component, EventEmitter, OnInit} from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { LoginService } from '../../services/login-service/login-service';
import { DataSharingService } from '../../services/login-service/data-sharing-service';
import { Observable, Subject, of, BehaviorSubject, throwError } from 'rxjs';

@Component({
  templateUrl: './admin.component.html',
  styleUrls: ['./admin.component.scss'],
  outputs: ['checkUserName'],
})
export class AdminComponent implements OnInit {
  public checkUserName = new EventEmitter();
  public isAuthenticated = false;

  loginEmitter$ = new BehaviorSubject<boolean>(this.isAuthenticated);
  public errorMessage = '';

  constructor(private loginService: LoginService,
              private router: Router,
              private route: ActivatedRoute,
              private dataSharingService: DataSharingService,
  ) {

  }

  ngOnInit() {
    this.isAuthenticated = false;
  }

  login(userName: string, password: string) {
    const TOKEN = 'token';

    this.loginService.loginToAPI(userName, password)
      .subscribe((data: any) => {
        data = data || [];
        if (data['token']) {
          let token = data['token'];
          localStorage.setItem(TOKEN, token);
          this.isAuthenticated = true;
          this.dataSharingService.isAuthenticated.next(this.isAuthenticated);
          this.dataSharingService.setData(token);
          const queryParams = this.route.snapshot.queryParams;
          const redirect = queryParams['redirect'] || '/admin/geheim';
          this.router.navigateByUrl(decodeURI(redirect));
        } else {
          this.errorMessage = data['code'] || '';
          this.errorMessage = data['token'] || this.errorMessage;
          if (this.errorMessage == '401') {
            this.errorMessage = 'Der Benutzername oder das Passwort sind ungültig';
          }
        }
      }
    );
  }

}
